<template>
  <div class="dropdowns">
    <label class="dropdowns__label">
      {{ title }}
    </label>
    <div class="dropdowns__container">
      <div
          class="dropdowns__dropdown"
          @click="toggle"
      >
        <button
            class="dropdowns__button"
            @click="toggleArrow"
        >
          {{ modelValue }}
          <span
              v-if="isActive"
              class="icon icon--arrow-new-up"
          ></span>
          <span
              v-else
              class="icon open icon--arrow-new-up"
          ></span>
        </button>

        <transition name="dropdown-content">
          <div
              class="dropdowns__content"
              v-if="isActive"
          >
            <div
                class="dropdowns__item"
                v-for="option in props.options"
            >
              <div
                  @click="onSelect(option)"
                  class="option"
              >{{ option.key }}
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref} from 'vue'

const props = defineProps({
  options: {},
  modelValue: '',
  title: '',
});

const emit = defineEmits([
  'update:modelValue',
  'onSelect',
  'search',
]);

const isActive = ref(false);

const onSelect = (e) => {
  emit("update:modelValue", e);
  emit("onSelect", e);
  emit("search");
}


function toggle() {
  isActive.value = !isActive.value;
}
</script>